/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InfoDialog/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import PatientInformation from 'DesignSystem/PatientInformation/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InfoDialog({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/InfoDialog",
  contentRef,
  left,
  top,
  onMouseEnter,
  update
  
}) {
let eventSelectedShowinfodialogValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'selected.showInfoDialog',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let eventIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'id',
})
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<fromFlow.When is={eventSelectedShowinfodialogValueData}>
<div
  data-testid="InfoDialog.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 onMouseEnter={onMouseEnter}
 style={{'--l-1-RaYLM': typeof left === 'number' ? `${left}px` : left,'--t-2-RaYLM': typeof top === 'number' ? `${top}px` : top,'--btlr-3-RaYLM': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-RaYLM': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-RaYLM': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-RaYLM': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-RaYLM': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-8-RaYLM': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-9-RaYLM': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-10-RaYLM': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-11-RaYLM': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-12-RaYLM': dtColorsWhite,'--bc-13-RaYLM': dtColorsNeutral100}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<PatientInformation
  viewPath={`${viewPath}/PatientInformation`}
 data="event.id"
 appointmentBookingId={eventIdValueData}
 update={update}
/>
</div>
</fromFlow.When>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}